import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "app"
};
import { initEnum } from "@/utils/iconEnum";
import { onBeforeUnmount, onMounted } from "vue";
export default {
  __name: 'App',
  setup(__props) {
    // 初始化
    initEnum();

    /**
     * 弹窗滚动锁定：
     * 只在“真正可见的弹窗”存在时生效。
     * 不再直接锁 .main-container，避免弹窗关闭后后台列表滑不动。
     */
    const getVisibleDialog = () => {
      const dialogs = Array.from(document.querySelectorAll('.el-dialog'));
      return dialogs.find(dialog => {
        const style = window.getComputedStyle(dialog);
        const rect = dialog.getBoundingClientRect();
        return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
      });
    };
    const isInDialog = target => {
      return !!(target && target.closest && target.closest('.el-dialog'));
    };
    const lockWheelOutsideDialog = event => {
      const dialog = getVisibleDialog();
      if (!dialog) return;
      if (isInDialog(event.target)) return;
      event.preventDefault();
    };
    const lockTouchOutsideDialog = event => {
      const dialog = getVisibleDialog();
      if (!dialog) return;
      if (isInDialog(event.target)) return;
      event.preventDefault();
    };
    onMounted(() => {
      document.addEventListener('wheel', lockWheelOutsideDialog, {
        capture: true,
        passive: false
      });
      document.addEventListener('touchmove', lockTouchOutsideDialog, {
        capture: true,
        passive: false
      });
    });
    onBeforeUnmount(() => {
      document.removeEventListener('wheel', lockWheelOutsideDialog, {
        capture: true
      });
      document.removeEventListener('touchmove', lockTouchOutsideDialog, {
        capture: true
      });
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view)]);
    };
  }
};